import { request } from "../../utils/axios";

export const fetchCourses = async () => {
  try {
    const res = await request.get(`public-courses`);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const fetchSingleCourse = async (id: number | string) => {
  try {
    const res = await request.get(`public/courses/${id}`);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const fetchAuthCourse = async () => {
  try {
    const res = await request.get(`courses`);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const fetchAuthSingleCourse = async (id: number | string) => {
  try {
    const res = await request.get(`courses/${id}`);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const fetchEnrollCourses = async () => {
  try {
    const res = await request.get(`courses/enrolled`);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const enroll = async (id: number | string) => {
  try {
    const res = await request.post(`courses/${id}/enroll`);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const fetchCourseProgress = async (id: number | string) => {
  try {
    const res = await request.get(`courses/${id}/completion`);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const fetchQuizProgress = async (id: number | string) => {
  try {
    const res = await request.get(`progress/content-items/${id}`);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const updateCourseProgress = async (id: number | string) => {
  try {
    const res = await request.post(`progress/content-items/${id}/complete`);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const submitQuiz = async ({
  id,
  answers,
}: {
  id: number | string;
  answers: any;
}) => {
  try {
    const res = await request.post(`progress/content-items/${id}/submit`, {
      answers,
    });
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const initializePayment = async (id: number | string) => {
  try {
    const res = await request.post(`courses/${id}/payments/initialize`);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const verifyPayment = async (reference: string) => {
  try {
    const res = await request.get(`payments/status`, {
      params: {
        reference,
      },
    });
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const videoProgress = async ({
  id,
  moduleId,
  courseId,
}: {
  id: number | string;
  moduleId: number | string;
  courseId: number | string;
}) => {
  try {
    const res = await request.post(
      `courses/${id}/modules/${moduleId}/videos/${courseId}/progress`
    );
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const generateCertificate = async ( id :  number | string ) => {
  try {
    const res = await request.get(`courses/${id}/certificate`);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const cloudinaryStream = async ( id :  number | string ) => {
  try {
    const res = await request.get(`videos/${id}/stream-url`);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

